import { render, staticRenderFns } from "./SampleHome.vue?vue&type=template&id=abfbd30c&scoped=true"
import script from "./SampleHome.vue?vue&type=script&lang=js"
export * from "./SampleHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfbd30c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abfbd30c')) {
      api.createRecord('abfbd30c', component.options)
    } else {
      api.reload('abfbd30c', component.options)
    }
    module.hot.accept("./SampleHome.vue?vue&type=template&id=abfbd30c&scoped=true", function () {
      api.rerender('abfbd30c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleHome.vue"
export default component.exports